import { isValidCountryCode } from "./isValidCountryCode"
import { getCountry } from "./getCountry"

export const routify = (countryCode, url) => {
  let route = url

  if (isValidCountryCode(countryCode)) {
    const country = getCountry(countryCode)

    route = "/" + country.slug + url
  }

  return route
}
